import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";
import { FAMILY_OFFER } from "../../../shared/magic-letter-box";

interface UpsellModalProps {
  open: boolean;
  onClose: () => void;
  onUpgradeClick?: () => void;
}

const UpsellModal: React.FC<UpsellModalProps> = ({
  open,
  onClose,
  onUpgradeClick,
}) => {
  return (
    <Dialog open={open} onOpenChange={(value) => (!value ? onClose() : undefined)}>
      <DialogContent className="max-w-lg rounded-3xl border border-elfRed/20 bg-gradient-to-br from-white via-elfGreen-light/50 to-white shadow-[0_40px_80px_rgba(196,30,58,0.25)]">
        <DialogHeader>
          <DialogTitle className="text-3xl font-extrabold text-foreground">
            Unlock Unlimited Elf Magic
          </DialogTitle>
          <DialogDescription className="text-base text-muted-foreground">
            You&apos;ve reached the free letter limit. Step into The Magic Letter Box for
            a Family membership at {FAMILY_OFFER.price}. Start with {FAMILY_OFFER.trialLetters} free letters in a separate account, then choose a paid plan for more.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-6 space-y-4">
          <div className="rounded-2xl bg-white/80 p-5 shadow-inner">
            <ul className="space-y-3 text-sm text-foreground">
              <li>🎁 Unlimited elf, Santa, arrival, and departure letters</li>
              <li>✨ Premium letterhead templates with the Family plan</li>
              <li>📝 Saved letter history and up to {FAMILY_OFFER.children} children</li>
              <li>🌟 Year-round characters: Tooth Fairy, Easter Bunny, and more</li>
            </ul>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <MagicLetterBoxLink
                source="generator-limit-modal"
                className="flex flex-1 items-center justify-center rounded-xl bg-elfRed-ink px-4 py-3 text-center text-sm font-semibold text-white hover:bg-[#892638] focus-visible:ring-2 focus-visible:ring-elfGreen-dark focus-visible:ring-offset-2"
                onClick={onUpgradeClick}
              >
                Continue at The Magic Letter Box
              </MagicLetterBoxLink>
            <Button
              variant="outline"
              className="flex-1 h-12 rounded-xl border-elfGreen/40 text-foreground"
              onClick={onClose}
            >
              Maybe Later
            </Button>
          </div>

          <p className="text-xs text-muted-foreground text-center">
            No credit card is needed for the trial. Your Elf Letter Bot letters do not transfer automatically.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UpsellModal;

